<template>
  <h1 class="text-center">FlipPlugin</h1>
</template>

<script>
export default {
  name: "FlipPlugin"
}
</script>

<style scoped>

</style>